export const ALL_STAFF_BUTTON_TEXT = 'Prepare for All-Staff'
export const EDIT_BUTTON_TEST_ID = 'Edit Goals'
export const FAMILIES_BUTTON_TEXT = 'Inform Families'
export const GET_STARTED_BUTTON_TEXT = 'Get Started'
export const GET_STARTED_BUTTON_TEST_ID = 'get-started-button'
export const GOALS_TEXT = 'Add Goals'
export const HEADER_TEXT_DEFAULT = 'Set Up for 2026-27'
export const HEADER_TEXT_SUMMARY = 'Setup Complete!'
export const IMPLEMENTATION_APPROACH_TEXT = 'Choose Approach'
export const MARK_COMPLETE_BUTTON_TEXT = 'Mark Complete'
export const PAGE_CONTENT_TEST_ID = 'playbook-steps-page-content'
export const PURPOSE_TEXT = 'Add Your Purpose'
export const RESUME_BUTTON_TEXT = 'Resume'
export const SUMMARY_LINK_TEXT = 'View 2026-27 Setup'
export const DATE_TEST_FLAG = 'BTS-2026_playbookDateTest'
export const BTS_2026_FLAG = 'LEARN-BTS-Playbook-2026'
export const GOAL_NOT_SET_WARNING_PREFIX = 'No goal set.'
export const GOAL_NOT_SET_ADD_GOAL_LINK_TEXT = 'Add a goal now.'
export const NO_SCHOOLWIDE_GOAL_MESSAGE = 'No schoolwide goal'
export const USERS_STAT_LABEL = 'Users'
export const USERS_WITHOUT_CLASSES_STAT_LABEL = 'without classes'
export const USERS_WITHOUT_ACCOUNTS_STAT_LABEL = 'pending'
export const MANAGE_USERS_LINK_TEXT = 'Manage Users'
export const USER_MANAGEMENT_PATH = '/user-management'
